import axios from "../../../common/utils/axios";
import BoutiqueService from "../../../common/services/boutique/BoutiqueService";

export default {
    state: {
        boutiqueData: {
            banners:[],
            dealers:[],
        },
        boutiqueEquipment:[],
        allBoutiques:[]
    },
    getters: {
        allBoutiques: (state) => {
            return state.allBoutiques;
        },
        boutiqueData: (state) => {
            return state.boutiqueData;
        },
        boutiqueEquipment: (state) => {
            return state.boutiqueEquipment;
        },
    },
    mutations: {
        boutiqueData(state, data) {
            state.boutiqueData = data;
        },
        boutiqueEquipment(state, data) {
            state.boutiqueEquipment = data;
        },
        allBoutiques(state, data) {
            state.allBoutiques = data;
        },
    },
    actions: {
        getBoutiqueData: async(context, data) => {
            var boutiqueService = new BoutiqueService();
            var result = await boutiqueService.getBoutiqueData(data);
            context.commit('boutiqueData', result.data.data)
            return result;
        },
        getBoutiqueEquipment: async(context, data) => {
            var boutiqueService = new BoutiqueService();
            var result = await boutiqueService.getBoutiqueEquipment(data);
            context.commit('boutiqueEquipment', result.data.data.kits.data)
            return result;
        },
        createDealer: async (context, data)=>{
            var boutiqueService = new BoutiqueService();
            data.phone_number = data.phone_dial + " " + data.phone_number
            var result =  await boutiqueService.createDealer(data);
            return result
        },
        getAllBoutiques: async (context)=>{
            var boutiqueService = new BoutiqueService();
            var result =  await boutiqueService.getAll();
            context.commit('allBoutiques', result.data.data)
            return result
        }
    },
};